export function generateTableResultChartSeaTrialsSeries(data, name, onLegendItemClick = null) {
  return {
    name: name,
    // color: "var(--kdiagram-table-data-points-color)",
    type: "spline",
    data: data,
    events: {
      legendItemClick: onLegendItemClick
    },
    marker: {
      enabled: true,
      symbol: "square",
      radius: 2,
    },
    animation: false,
    states: {
      hover: {
        enabled: false,
      },
    },
    visible: false
  };
}
